/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import SiderComponent from './../components/SiderComponent';
import HeaderComponent from './../components/HeaderComponent';
import DealPicturePlaceholder from './../assets/DealPicturePlaceholder.jpg';
import { formatedDealPeriodObject, refresh } from '../utils/Utils';
import { useSelector, useDispatch } from 'react-redux';
import {
  setGolfClubDetails,
  setTmpCourseId,
  setTmpDealCourses,
  setNewDealCourses,
} from '../redux/actions/golfClubActions';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { DeleteFilled } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/de_DE';
import {
  Layout,
  Form,
  Input,
  Button,
  Row,
  Col,
  InputNumber,
  Select,
  DatePicker,
  Upload,
  notification,
  Popconfirm,
  Checkbox,
  TimePicker,
  Radio,
  Tag,
} from 'antd';
import greenfeeDealsApi from '../api/greenfeeDeals';

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;

const CATEGORIES = [
  { value: 'Events & Turniere', label: 'Events & Turniere' },
  { value: 'Kurse & Reisen', label: 'Kurse & Reisen' },
  { value: 'Equipment', label: 'Equipment' },
  { value: 'Greenfee-Specials', label: 'Greenfee-Specials' },
];

const dateFormat = 'DD-MM-YY'; // keep old format as requested
const timeFormat = 'HH:mm';

function isDealOnline(deal) {
  // Online = current day is in defined range OR deal starts in the future
  // Offline = defined date is in the past
  if (!deal?.dealPeriod?.from || !deal?.dealPeriod?.to) return false;
  const today = moment().startOf('day');
  const from = moment(deal.dealPeriod.from).startOf('day');
  const to = moment(deal.dealPeriod.to).endOf('day');
  if (to.isBefore(today)) return false; // fully past => offline
  if (from.isAfter(today)) return true; // starts in future => online
  return today.isBetween(from, to, null, '[]'); // in range (inclusive)
}

async function notifyOnChange({ golfClubId, dealId, payload, headers }) {
  // Non-breaking: try a notification endpoint; ignore if it doesn't exist
  try {
    // Option A: separate notifications endpoint (preferred if you have it)
    await greenfeeDealsApi.post(
      `/notifications/topdeal`,
      {
        golfClubId,
        dealId,
        recipients: ['club', 'topdeal@greenfee-deals.de'],
        payload,
      },
      headers,
    );
  } catch (e1) {
    // Option B: pass a notify flag to existing endpoints (safe no-op if ignored)
    try {
      await greenfeeDealsApi.post(
        `/notifications/fallback`,
        {
          golfClubId,
          dealId,
          recipients: ['club', 'topdeal@greenfee-deals.de'],
          payload,
        },
        headers,
      );
    } catch (e2) {
      // swallow silently to avoid breaking UX
    }
  }
}

function TopDeals(props) {
  const { mode, dealId } = props;
  // SESSION PARAMS
  const sessionBnd = localStorage.getItem('sessionBnd');
  const [newDealImage, setNewDealImage] = useState(null);
  const [dealImages, setDealImages] = useState([]);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const headers = {
    headers: { Authorization: `Bearer ${sessionBnd}` },
  };
  const navigate = useNavigate();
  // REDUX
  const dispatch = useDispatch();
  const golfClubDetails = useSelector(
    (state) => state.golfClub.golfClubDetails,
  );

  if (!golfClubDetails) {
    props.history.push(`/`);
    return <div />;
  }
  if (!golfClubDetails.topDeals) {
    golfClubDetails.topDeals = [];
  }

  useEffect(() => {
    fetchDealImages();
  }, []);

  const fetchDealImages = async () => {
    try {
      const res = await greenfeeDealsApi.get('/deal-images', headers);
      setDealImages(res.data.data); // API returns array of image objects
    } catch (error) {
      console.log('Failed loading deal images');
    }
  };
  const [selectedDealImage, setSelectedDealImage] = useState(null);

  // FORM
  const [form] = Form.useForm();

  const golfClubId = golfClubDetails._id.golfClub;

  // ---------- SAVE: NEW ----------
  const saveNewDeal = async (values) => {
    let newDeal = { ...values.newDealValues };

    if (newDeal.discountType === '%') {
      const percent = newDeal.discountAmount.replace(',', '.');
      newDeal.discountPercent = percent;
      newDeal.discountPrice = '';
    } else {
      newDeal.discountPrice = String(newDeal.discountAmount || '')
        .replace(/[€\s]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
      newDeal.discountPercent = '';
    }

    const dealPeriod = formatedDealPeriodObject(values.newDealPeriod);
    newDeal.dealPeriod = dealPeriod;

    newDeal.isAllDay = !!newDeal.isAllDay;
    if (newDeal.isAllDay) {
      newDeal.startTime = '';
      newDeal.endTime = '';
    } else {
      newDeal.startTime = newDeal.startTime
        ? moment(newDeal.startTime).format(timeFormat)
        : '';
      newDeal.endTime = newDeal.endTime
        ? moment(newDeal.endTime).format(timeFormat)
        : '';
    }

    newDeal.isFreeDeal = !!newDeal.isFreeDeal;
    console.log('--172---', newDeal);
    try {
      // ---------- STEP 1: Save Deal ----------
      const postDeal = await greenfeeDealsApi.post(
        `/golfclubs/${golfClubId}/topDeals`,
        newDeal,
        headers,
      );

      // STEP 2: Extract newly created topDeal ID
      const topDeals = postDeal?.data?.data?.data?.topDeals || [];
      const createdDealId = topDeals[topDeals.length - 1]?._id;

      console.log('Newly created TopDeal ID:', createdDealId);
      console.log('createdDealId:::::::::::::::', createdDealId);

      // ---------- STEP 2: Upload Image AFTER deal is saved ----------
      if (newDealImage && createdDealId) {
        // User uploaded a NEW image
        await uploadImage(
          {
            file: newDealImage,
            onSuccess: () => {},
            onError: () => {},
            onProgress: () => {},
          },
          createdDealId,
        );
      } else if (selectedDealImage && createdDealId) {
        // User selected EXISTING admin-uploaded image
        await greenfeeDealsApi.patch(
          `/golfclubs/${golfClubId}/topdeals/${createdDealId}`,
          { existingImage: selectedDealImage },
          headers,
        );
      }

      // ---------- STEP 3: Notification ----------
      await notifyOnChange({
        golfClubId,
        dealId: createdDealId,
        payload: newDeal,
        headers,
      });

      // ---------- STEP 4: Refresh golf club ----------
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );

      dispatch(setGolfClubDetails(golfClub.data.data.data));
      form.resetFields();
      setNewDealImage(null);

      notification.success({
        message: 'Update Successful',
        description: 'The golf club details have been updated successfully.',
      });
      setTimeout(() => {
        navigate('/deals/topdeals');
      }, 1000);
    } catch (error) {
      console.log('Error while saving deal: ', error);
    }
  };

  // ---------- SAVE: EXISTING ----------
  const saveExisDeal = async (values) => {
    let deal = { ...values.dealValues };
    console.log('----', values);
    // discount mapping (existing behavior)
    if (deal.discountType === '%') {
      deal.discountPercent = String(deal.discountAmount ?? '')
        .replace(',', '.')
        .replace(' €', '')
        .replace('€', '');
      deal.discountPrice = '';
    } else {
      deal.discountPrice = String(deal.discountAmount ?? '')
        .replace(/[€\s]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
      deal.discountPercent = '';
    }
    // dates
    if (values.dealPeriod) {
      const dealPeriod = formatedDealPeriodObject(values.dealPeriod);
      deal.dealPeriod = dealPeriod;
    }

    // all-day + times
    deal.isAllDay = !!deal.isAllDay;
    if (deal.isAllDay) {
      deal.startTime = '';
      deal.endTime = '';
    } else {
      deal.startTime = deal.startTime
        ? moment(deal.startTime).format(timeFormat)
        : '';
      deal.endTime = deal.endTime
        ? moment(deal.endTime).format(timeFormat)
        : '';
    }

    // free deal
    deal.isFreeDeal = !!deal.isFreeDeal;

    try {
      const updateDeal = await greenfeeDealsApi.patch(
        `/golfclubs/${golfClubId}/topDeals/${deal._id}`,
        deal,
        headers,
      );

      // notify (non-blocking)
      notifyOnChange({
        golfClubId,
        dealId: deal._id,
        payload: deal,
        headers,
      });

      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        return;
      }
      const results = golfClub.data.data.data;

      dispatch(setGolfClubDetails(results));
      notification.success({
        message: 'Update Successful',
        description: 'The golf club details have been updated successfully.',
      });
      setTimeout(() => {
        navigate('/deals/topdeals');
      }, 1000);
    } catch (error) {
      // keep silence like your current code
    }
  };

  // DELETE (unchanged)
  const deleteDeal = async (dealId) => {
    try {
      await greenfeeDealsApi.delete(
        `/golfclubs/${golfClubId}/topDeals/${dealId}`,
        headers,
      );
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        return;
      }
      const results = golfClub.data.data.data;

      dispatch(setGolfClubDetails(results));
      notification.success({
        message: 'Deleted Deal Successfully',
        description: 'The golf club details have been deleted successfully.',
      });
    } catch (error) {}
  };

  // UPLOAD IMAGE (unchanged)
  const uploadImage = async (options, id) => {
    const { onSuccess, onError, file, onProgress } = options;
    const uploadImageData = new FormData();
    uploadImageData.append('dealImage', file);
    try {
      await greenfeeDealsApi.patch(
        `/golfclubs/${golfClubId}/topdeals/${id}`,
        uploadImageData,
        headers,
      );
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        console.log('Error no Golfclub found for your Admin Account');
        return;
      }
      const results = golfClub.data.data.data;

      dispatch(setGolfClubDetails(results));
      notification.success({
        message: 'Uploaded Image Successfully',
        description: 'The golf club image have been uploaded successfully.',
      });
    } catch (err) {
      console.log('Eroor: ', err);
      onError({ err });
    }
  };

  const cancel = (e) => {
    console.log(e);
  };

  return (
    <div>
      <Layout style={{ minHeight: '100vh' }}>
        <SiderComponent props={props} />
        <Layout>
          <HeaderComponent />
          <Content
            style={{
              backgroundColor: '#EAEAEA',
              padding: 50,
            }}
          >
            {/* <h3 style={{ marginTop: 30 }} >Top Deals</h3> */}
            {mode === 'create' && (
              <>
                <div
                  style={{
                    backgroundColor: 'white',
                    borderRadius: 8,
                    width: '100%',
                    padding: '32px',
                    marginTop: 0,
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
                  }}
                >
                  <h2 className="Form-heading">Top Deal erstellen</h2>

                  <Form
                    onFinish={saveNewDeal}
                    form={form}
                    initialValues={{
                      newDealValues: {
                        discountType: '€',
                        isAllDay: false,
                        isFreeDeal: false,
                        category: undefined,
                      },
                    }}
                    style={{ marginBlockStart: 20 }}
                    className="create-top-deals-form"
                  >
                    {/* Title and Category Row */}
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <div>
                          <label className="label-style-clsnn">
                            Titel (max. 65 Zeichen)
                          </label>
                        </div>
                        <Form.Item
                          name={['newDealValues', 'title']}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            placeholder="Geben Sie hier den Titel ein"
                            required
                            maxLength={65}
                            minLength={10}
                            style={{
                              height: 40,
                              borderRadius: 6,
                              fontSize: 14,
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={5}>
                        <div>
                          <label className="label-style-clsnn">
                            Kategorie wählen
                          </label>
                        </div>
                        <Form.Item
                          name={['newDealValues', 'category']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select a category',
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Select
                            placeholder="Kategorie bestimmen"
                            allowClear
                            style={{
                              height: 40,
                            }}
                          >
                            {CATEGORIES.map((c) => (
                              <Option key={c.value} value={c.value}>
                                {c.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* Price/Discount Row */}
                    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                      <Col span={6}>
                        <div>
                          <label className="label-style-clsnn">
                            Preis (€) oder Rabatt (%) angeben
                          </label>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            gap: 8,
                            alignItems: 'flex-start',
                          }}
                        >
                          <Form.Item
                            name={['newDealValues', 'discountType']}
                            style={{ marginBottom: 0, width: 80 }}
                          >
                            <Select
                              defaultValue="€"
                              style={{
                                width: '100%',
                                height: 40,
                              }}
                            >
                              <Option value="%">%</Option>
                              <Option value="€">€</Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            noStyle
                            shouldUpdate={(p, c) =>
                              p?.newDealValues?.isFreeDeal !==
                              c?.newDealValues?.isFreeDeal
                            }
                          >
                            {({ getFieldValue }) => {
                              const free = getFieldValue([
                                'newDealValues',
                                'isFreeDeal',
                              ]);
                              return (
                                <Form.Item
                                  name={['newDealValues', 'discountAmount']}
                                  style={{ marginBottom: 0 }}
                                >
                                  <InputNumber
                                    placeholder="0.00"
                                    disabled={!!free}
                                    stringMode
                                    style={{
                                      width: '100%',
                                      height: 40,
                                      borderRadius: 6,
                                    }}
                                    parser={(value) =>
                                      value
                                        ?.replace(/[€\s]/g, '')
                                        .replace(/\./g, '')
                                        .replace(',', '.')
                                    }
                                    formatter={(value) => {
                                      if (!value && value !== 0) return '';
                                      const cleaned = String(value).replace(/[€\s]/g, '').replace(',', '.');
                                      const num = parseFloat(cleaned);
                                      if (isNaN(num)) return String(value);
                                      return Number.isInteger(num)
                                        ? num.toLocaleString('de-DE')
                                        : num.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    }}
                                    onBlur={(e) => {
                                      let v = e.target.value;
                                      if (!v) return;
                                      v = v
                                        .replace(/[€\s]/g, '')
                                        .replace(/\./g, '')
                                        .replace(',', '.');
                                      const num = Number(v);
                                      if (isNaN(num)) return;

                                      const rounded = Math.round(num * 100) / 100;
                                      const formatted = Number.isInteger(rounded)
                                        ? rounded.toLocaleString('de-DE')
                                        : rounded.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                                      form.setFieldsValue({
                                        newDealValues: {
                                          ...form.getFieldValue('newDealValues'),
                                          discountAmount: formatted,
                                        },
                                      });
                                    }}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>

                          <Form.Item
                            name={['newDealValues', 'isFreeDeal']}
                            valuePropName="checked"
                            style={{ marginBottom: 0 }}
                          >
                            <Checkbox>kostenfrei</Checkbox>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>

                    {/* Date and Time Row - KEEPING ORIGINAL LAYOUT */}
                    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                      {/* <Col span={6}>
                        <div>
                          <label className="label-style-clsnn">
                            Start date
                          </label>
                        </div>
                        <Form.Item
                          name={["newDealPeriod"]}
                          style={{ marginBottom: 0 }}
                        >
                          <DatePicker
                            // onChange={onChange}
                            allowClear={false}
                            format={dateFormat}
                            locale={locale}
                            style={{ width: "100%" }}
                            required
                            className="picker-design-styl" */}
                      {/* /> */}
                      {/* <RangePicker
                            allowClear={false}
                            format={dateFormat}
                            locale={locale}
                            style={{ width: "100%" }}
                            required
                          /> */}
                      {/* </Form.Item>
                      </Col> */}

                      <Col span={8}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          <label
                            style={{
                              fontSize: 13,
                              color: '#595959',
                              fontWeight: 500,
                              display: 'block',
                              width: '50%',
                            }}
                          >
                            Startdatum
                          </label>
                          <label
                            style={{
                              fontSize: 13,
                              color: '#595959',
                              fontWeight: 500,
                              display: 'block',
                              width: '50%',
                            }}
                          >
                            Enddatum
                          </label>
                        </div>
                        <Form.Item
                          name={['newDealPeriod']}
                          style={{ marginBottom: 0 }}
                        >
                          <RangePicker
                            allowClear={false}
                            format={dateFormat}
                            locale={locale}
                            style={{ width: '100%' }}
                            required
                            className="picker-design-styl"
                          />
                        </Form.Item>
                      </Col>

                      <Col span={3}>
                        <div>
                          <label className="label-style-clsnn">Beginn</label>
                        </div>
                        <Form.Item
                          shouldUpdate={(p, c) =>
                            p?.newDealValues?.isAllDay !==
                            c?.newDealValues?.isAllDay
                          }
                          noStyle
                        >
                          {({ getFieldValue }) => {
                            const allDay = getFieldValue([
                              'newDealValues',
                              'isAllDay',
                            ]);
                            return (
                              <Form.Item
                                name={['newDealValues', 'startTime']}
                                style={{ marginBottom: 0 }}
                              >
                                <TimePicker
                                  format={timeFormat}
                                  style={{ width: '100%' }}
                                  placeholder="--:-- --"
                                  disabled={!!allDay}
                                  className="picker-design-styl"
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>

                      <Col span={3}>
                        <div>
                          <label className="label-style-clsnn">Ende</label>
                        </div>
                        <Form.Item
                          shouldUpdate={(p, c) =>
                            p?.newDealValues?.isAllDay !==
                            c?.newDealValues?.isAllDay
                          }
                          noStyle
                        >
                          {({ getFieldValue }) => {
                            const allDay = getFieldValue([
                              'newDealValues',
                              'isAllDay',
                            ]);
                            return (
                              <Form.Item
                                name={['newDealValues', 'endTime']}
                                style={{ marginBottom: 0 }}
                              >
                                <TimePicker
                                  format={timeFormat}
                                  style={{ width: '100%' }}
                                  placeholder="--:-- --"
                                  className="picker-design-styl"
                                  disabled={!!allDay}
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>

                      <Col span={4}>
                        <div style={{ visibility: 'hidden' }}>
                          <label style={{ fontSize: 13 }}>.</label>
                        </div>
                        <Form.Item
                          name={['newDealValues', 'isAllDay']}
                          valuePropName="checked"
                          style={{ marginBottom: 0, marginTop: 8 }}
                        >
                          <Checkbox>Ganztägig</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* Description */}
                    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                      <Col span={24}>
                        <div>
                          <label className="label-style-clsnn">
                            Beschreibung
                          </label>
                        </div>
                        <Form.Item
                          name={['newDealValues', 'description']}
                          style={{ marginBottom: 0 }}
                        >
                          <TextArea
                            rows={4}
                            placeholder="Geben Sie hier die Beschreibung ein..."
                            required
                            style={{
                              borderRadius: 6,
                              fontSize: 14,
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* URL */}
                    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                      <Col span={24}>
                        <div>
                          <label className="label-style-clsnn">
                            Link für weitere Informationen
                          </label>
                        </div>
                        <Form.Item
                          name={['newDealValues', 'dealUrl']}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            placeholder="https://example.com/deal"
                            required
                            style={{
                              height: 40,
                              borderRadius: 6,
                              fontSize: 14,
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    {/* Image Selection */}
                    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                      <Col span={24}>
                        <div style={{ marginBottom: 12 }}>
                          <label className="label-style-clsnn">
                            Wählen Sie ein Bild oder laden ein eigenes Bild
                            hoch. (Ein eigenes Bild in den Maßen: 1485x683px)
                          </label>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 12,
                          }}
                        >
                          {/* Existing gallery images */}
                          {dealImages.map((imgObj) => {
                            const isSelected =
                              selectedDealImage === imgObj.image;

                            return (
                              <div
                                key={imgObj._id}
                                onClick={() => {
                                  setSelectedDealImage(imgObj.image);
                                  setNewDealImage(null);
                                  setPreviewImageUrl(null);
                                }}
                                style={{
                                  border: isSelected
                                    ? '2px solid #1890ff'
                                    : '1px solid #E8E8E8',
                                  borderRadius: 8,
                                  cursor: 'pointer',
                                  overflow: 'hidden',
                                  maxWidth: '140px',
                                  height: 115,
                                  transition: 'all 0.3s',
                                }}
                              >
                                <img
                                  src={`https://greenfeedeals2.s3.eu-central-1.amazonaws.com/${imgObj.image}`}
                                  alt=""
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                              </div>
                            );
                          })}

                          {/* Preview of newly uploaded image */}
                          {previewImageUrl && (
                            <div
                              key="preview-image"
                              onClick={() => {
                                setSelectedDealImage(null);
                              }}
                              style={{
                                border: newDealImage
                                  ? '3px solid #1890ff'
                                  : '2px solid #E8E8E8',
                                borderRadius: 8,
                                cursor: 'pointer',
                                overflow: 'hidden',
                                maxWidth: '140px',
                                width: '100%',
                                height: 115,
                                transition: 'all 0.3s',
                              }}
                            >
                              <img
                                src={previewImageUrl}
                                alt="preview"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          )}

                          {/* Upload button */}
                          <Upload
                            showUploadList={false}
                            beforeUpload={(file) => {
                              setNewDealImage(file);
                              setSelectedDealImage(null);
                              setPreviewImageUrl(URL.createObjectURL(file));
                              return false;
                            }}
                          >
                            <div
                              style={{
                                maxWidth: '140px',
                                width: '100%',
                                height: 115,
                                border: '2px dashed #D9D9D9',
                                borderRadius: 8,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                background: '#FAFAFA',
                                transition: 'all 0.3s',
                                flexDirection: 'column',
                                gap: 8,
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#1890FF';
                                e.currentTarget.style.background = '#F0F5FF';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#D9D9D9';
                                e.currentTarget.style.background = '#FAFAFA';
                              }}
                            >
                              <div
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  background: '#E6F7FF',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: 20,
                                  color: '#1890FF',
                                }}
                              >
                                +
                              </div>
                              <div
                                style={{
                                  fontSize: 12,
                                  color: '#8C8C8C',
                                  textAlign: 'center',
                                  padding: '0 8px',
                                }}
                              >
                                Upload your image
                              </div>
                              <div
                                style={{
                                  fontSize: 10,
                                  color: '#BFBFBF',
                                }}
                              >
                                Max size: 5MB
                              </div>
                            </div>
                          </Upload>
                        </div>
                      </Col>
                    </Row>

                    {/* Save Button */}
                    <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
                      <Col
                        span={24}
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            minWidth: 120,
                            height: 40,
                            borderRadius: 6,
                            fontSize: 14,
                            fontWeight: 500,
                            border: 0,
                            backgroundColor: '#1B392F',
                          }}
                        >
                          Speichern
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </>
            )}

            {/* <hr
              style={{
                border: "0.3px dotted rgba(0, 0, 0, 0.85)",
                marginTop: 30,
              }}
            /> */}

            {/* <h5 style={{ marginTop: 30 }}>Bestehende Deals editieren</h5> */}

            {/* ---------- EXISTING DEALS LIST ---------- */}
            {mode === 'edit' &&
              golfClubDetails.topDeals
                .filter((deal) => deal._id === dealId)
                .map((deal) => {
                  // normalize for initial form values (existing behavior)
                  let dealPeriod = [];
                  if (deal.discountPercent) {
                    deal.discountType = '%';
                    deal.discountAmount = deal.discountPercent;
                  } else {
                    if (!deal.discountType) {
                      deal.discountType = '€';
                      deal.discountAmount = deal.discountPrice;
                    } else {
                      deal.discountAmount = deal.discountPrice;
                    }
                  }

                  if (deal.dealPeriod) {
                    dealPeriod = [
                      moment(deal.dealPeriod.from),
                      moment(deal.dealPeriod.to),
                    ];
                  }

                  // time initials
                  const startTimeInit = deal.startTime
                    ? moment(deal.startTime, timeFormat)
                    : null;
                  const endTimeInit = deal.endTime
                    ? moment(deal.endTime, timeFormat)
                    : null;

                  const online = isDealOnline(deal);

                  return (
                    <div
                      key={deal._id}
                      style={{
                        backgroundColor: 'white',
                        borderRadius: 8,
                        width: '100%',
                        padding: '32px',
                        marginTop: 0,
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
                      }}
                      className="create-top-deals-form"
                    >
                      <Form
                        onFinish={saveExisDeal}
                        hideRequiredMark
                        initialValues={{
                          dealValues: {
                            ...deal,
                            isAllDay: !!deal.isAllDay,
                            isFreeDeal: !!deal.isFreeDeal,
                            startTime: startTimeInit,
                            endTime: endTimeInit,
                          },
                        }}
                      >
                        <Form.Item
                          name={['dealValues', '_id']}
                          className="noHeight"
                        >
                          <span />
                        </Form.Item>

                        {/* Title Row */}
                        <Row gutter={[16, 16]}>
                          <Col span={12}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Titel (max. 65 Zeichen)
                              </label>
                            </div>
                            <Form.Item
                              name={['dealValues', 'title']}
                              style={{ marginBottom: 0 }}
                            >
                              <Input
                                placeholder="Weekend Golf Package"
                                maxLength={65}
                                style={{
                                  height: 40,
                                  borderRadius: 6,
                                  fontSize: 14,
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={5}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Kategorie wählen
                              </label>
                            </div>
                            <Form.Item
                              name={['dealValues', 'category']}
                              style={{ marginBottom: 0 }}
                            >
                              <Select
                                placeholder="Club associations"
                                style={{
                                  height: 40,
                                }}
                              >
                                {CATEGORIES.map((c) => (
                                  <Option key={c.value} value={c.value}>
                                    {c.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>

                        {/* Price and Category Row */}
                        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                          <Col span={6}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Preis (€) oder Rabatt (%) angeben
                              </label>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                gap: 8,
                                alignItems: 'flex-start',
                              }}
                            >
                              <Form.Item
                                name={['dealValues', 'discountType']}
                                style={{ marginBottom: 0, width: 80 }}
                              >
                                <Select
                                  defaultValue="%"
                                  style={{
                                    width: '100%',
                                    height: 40,
                                  }}
                                  onChange={(newType) => {
                                    // Get current amount, strip any € symbol
                                    const currentAmount = form.getFieldValue([
                                      'dealValues',
                                      'discountAmount',
                                    ]);
                                    if (!currentAmount) return;
                                    let cleaned = String(currentAmount)
                                      .replace(' €', '')
                                      .replace('€', '')
                                      .replace(',', '.');
                                    const num = Number(cleaned);
                                    if (isNaN(num)) return;
                                    const rounded = Math.round(num * 100) / 100;
                                    let formatted = rounded.toFixed(2);
                                    const numFormatted = parseFloat(formatted);
                                    formatted = Number.isInteger(numFormatted)
                                      ? numFormatted.toLocaleString('de-DE')
                                      : numFormatted.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    form.setFieldsValue({
                                      dealValues: {
                                        ...form.getFieldValue('dealValues'),
                                        discountAmount: formatted,
                                      },
                                    });
                                  }}
                                >
                                  <Option value="%">%</Option>
                                  <Option value="€">€</Option>
                                </Select>
                              </Form.Item>

                              <Form.Item
                                noStyle
                                shouldUpdate={(p, c) =>
                                  p?.dealValues?.isFreeDeal !==
                                    c?.dealValues?.isFreeDeal ||
                                  p?.dealValues?.discountType !==
                                    c?.dealValues?.discountType
                                }
                              >
                                {({ getFieldValue }) => {
                                  const free = getFieldValue([
                                    'dealValues',
                                    'isFreeDeal',
                                  ]);
                                  const discountType = getFieldValue([
                                    'dealValues',
                                    'discountType',
                                  ]);
                                  return (
                                    <Form.Item
                                      name={['dealValues', 'discountAmount']}
                                      style={{ marginBottom: 0, flex: 1 }}
                                    >
                                      <InputNumber
                                        placeholder="10.50"
                                        style={{
                                          width: '100%',
                                          height: 40,
                                          borderRadius: 6,
                                        }}
                                        disabled={!!free}
                                        stringMode
                                        formatter={(value) => {
                                          if (!value && value !== 0) return '';
                                          const cleaned = String(value).replace(/[€\s]/g, '').replace(',', '.');
                                          const num = parseFloat(cleaned);
                                          if (isNaN(num)) return String(value);
                                          return Number.isInteger(num)
                                            ? num.toLocaleString('de-DE')
                                            : num.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                        }}
                                        parser={(value) => {
                                          if (!value) return '';
                                          return value
                                            .replace(/[€\s]/g, '')
                                            .replace(/\./g, '')
                                            .replace(',', '.');
                                        }}
                                        onBlur={(e) => {
                                          let v = e.target.value;

                                          if (
                                            v === '' ||
                                            v === null ||
                                            v === undefined
                                          )
                                            return;
                                          const discountType = getFieldValue([
                                            'dealValues',
                                            'discountType',
                                          ]);
                                          console.log(
                                            '---1222----',
                                            discountType,
                                          );
                                          v = String(v)
                                            .replace(' €', '')
                                            .replace('€', '')
                                            .replace(',', '.');

                                          const num = Number(v);
                                          if (isNaN(num)) return;

                                          const rounded =
                                            Math.round(num * 100) / 100;
                                          let fixed = rounded.toFixed(2);

                                          const rounded2 = parseFloat(fixed);
                                          fixed = Number.isInteger(rounded2)
                                            ? rounded2.toLocaleString('de-DE')
                                            : rounded2.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                          form.setFieldsValue({
                                            dealValues: {
                                              ...form.getFieldValue(
                                                'dealValues',
                                              ),
                                              discountAmount: fixed,
                                            },
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>

                              <Form.Item
                                name={['dealValues', 'isFreeDeal']}
                                valuePropName="checked"
                                style={{ marginBottom: 0 }}
                              >
                                <Checkbox>kostenfrei</Checkbox>
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>

                        {/* Date and Time Row - KEEPING ORIGINAL LAYOUT */}
                        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                          <Col span={8}>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                              }}
                            >
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                  width: '50%',
                                }}
                              >
                                Startdatum
                              </label>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                  width: '50%',
                                }}
                              >
                                Enddatum
                              </label>
                            </div>
                            <Form.Item
                              name={['dealPeriod']}
                              style={{ marginBottom: 0 }}
                            >
                              <RangePicker
                                allowClear={false}
                                format={dateFormat}
                                locale={locale}
                                style={{ width: '100%' }}
                                defaultValue={dealPeriod}
                                className="picker-design-styl"
                              />
                            </Form.Item>
                          </Col>

                          {/* <Col span={6}>
                            <div>
                              
                            </div>
                            {/* This is handled by RangePicker above, keeping layout consistent */}
                          {/* <DatePicker
                                // onChange={onChange}
                                allowClear={false}
                                format={dateFormat}
                                locale={locale}
                                style={{ width: "100%" }}
                                required
                                defaultValue={dealPeriod.to}
                                
                              /> */}
                          {/* <div style={{ height: 40 }}></div> */}
                          {/* </Col> */}

                          <Col span={3}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Beginn
                              </label>
                            </div>
                            <Form.Item
                              shouldUpdate={(p, c) =>
                                p?.dealValues?.isAllDay !==
                                c?.dealValues?.isAllDay
                              }
                              noStyle
                            >
                              {({ getFieldValue }) => {
                                const allDay = getFieldValue([
                                  'dealValues',
                                  'isAllDay',
                                ]);
                                return (
                                  <Form.Item
                                    name={['dealValues', 'startTime']}
                                    style={{ marginBottom: 0 }}
                                  >
                                    <TimePicker
                                      format={timeFormat}
                                      style={{ width: '100%' }}
                                      placeholder="--:-- --"
                                      disabled={!!allDay}
                                      className="picker-design-styl"
                                    />
                                  </Form.Item>
                                );
                              }}
                            </Form.Item>
                          </Col>

                          <Col span={3}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Ende
                              </label>
                            </div>
                            <Form.Item
                              shouldUpdate={(p, c) =>
                                p?.dealValues?.isAllDay !==
                                c?.dealValues?.isAllDay
                              }
                              noStyle
                            >
                              {({ getFieldValue }) => {
                                const allDay = getFieldValue([
                                  'dealValues',
                                  'isAllDay',
                                ]);
                                return (
                                  <Form.Item
                                    name={['dealValues', 'endTime']}
                                    style={{ marginBottom: 0 }}
                                  >
                                    <TimePicker
                                      format={timeFormat}
                                      style={{ width: '100%' }}
                                      placeholder="--:-- --"
                                      disabled={!!allDay}
                                      className="picker-design-styl"
                                    />
                                  </Form.Item>
                                );
                              }}
                            </Form.Item>
                          </Col>

                          <Col span={4}>
                            <div style={{ visibility: 'hidden' }}>
                              <label style={{ fontSize: 13 }}>.</label>
                            </div>
                            <Form.Item
                              name={['dealValues', 'isAllDay']}
                              valuePropName="checked"
                              style={{ marginBottom: 0, marginTop: 8 }}
                            >
                              <Checkbox>Ganztägig</Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>

                        {/* Description */}
                        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                          <Col span={24}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Beschreibung
                              </label>
                            </div>
                            <Form.Item
                              name={['dealValues', 'description']}
                              style={{ marginBottom: 0 }}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enjoy our full course on your championship course. Valid on weekends only."
                                maxLength={1000}
                                style={{
                                  borderRadius: 6,
                                  fontSize: 14,
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        {/* URL */}
                        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                          <Col span={24}>
                            <div>
                              <label
                                style={{
                                  fontSize: 13,
                                  color: '#595959',
                                  fontWeight: 500,
                                  display: 'block',
                                }}
                              >
                                Link für weitere Informationen
                              </label>
                            </div>
                            <Form.Item
                              name={['dealValues', 'dealUrl']}
                              style={{ marginBottom: 0 }}
                            >
                              <Input
                                placeholder="https://example.com/deal"
                                style={{
                                  height: 40,
                                  borderRadius: 6,
                                  fontSize: 14,
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        {/* Image Upload - Keep existing */}
                        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                          <Col span={24}>
                            <div style={{ marginBottom: 12 }}>
                              <label className="label-style-clsnn">
                                Wählen Sie ein Bild oder laden ein eigenes Bild
                                hoch. (Ein eigenes Bild in den Maßen:
                                1485x683px)
                              </label>
                            </div>
                            <Upload
                              name="avatar"
                              showUploadList={false}
                              customRequest={(options) => {
                                uploadImage(options, deal._id);
                              }}
                            >
                              {deal.dealImage ? (
                                <img
                                  src={`https://greenfeedeals2.s3.eu-central-1.amazonaws.com/${deal.dealImage}`}
                                  alt="avatar"
                                  style={{
                                    width: '100%',
                                    maxWidth: 400,
                                    cursor: 'pointer',
                                    borderRadius: 8,
                                  }}
                                />
                              ) : (
                                <img
                                  src={DealPicturePlaceholder}
                                  alt="avatar"
                                  style={{
                                    width: '100%',
                                    maxWidth: 400,
                                    cursor: 'pointer',
                                    borderRadius: 8,
                                  }}
                                />
                              )}
                            </Upload>
                          </Col>
                        </Row>

                        {/* Action Buttons */}
                        <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
                          <Col
                            span={24}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Popconfirm
                              title="Delete this deal"
                              description="Are you sure?"
                              icon={
                                <QuestionCircleOutlined
                                  style={{ color: 'red' }}
                                />
                              }
                              onConfirm={() => deleteDeal(deal._id)}
                              onCancel={cancel}
                              okText="Confirm"
                              cancelText="Cancel"
                            >
                              <Button
                                danger
                                type="text"
                                icon={<DeleteFilled />}
                                style={{
                                  color: '#FF4D4F',
                                  fontSize: 14,
                                  visibility: 'hidden',
                                }}
                              >
                                Delete Deal
                              </Button>
                            </Popconfirm>

                            <Button
                              type="primary"
                              htmlType="submit"
                              style={{
                                minWidth: 120,
                                height: 40,
                                borderRadius: 6,
                                fontSize: 14,
                                fontWeight: 500,
                              }}
                            >
                              Speichern
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  );
                })}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default TopDeals;
